import api from "./api";

// Per-user in-app notification inbox (the bell in the header). Every endpoint is
// scoped to the authenticated user on the backend, so no user id is sent.
const BASE_PATH = "/api/user-notification";

const list = () => api.get(`${BASE_PATH}/list`);

const getUnreadCount = () => api.get(`${BASE_PATH}/unread_count`);

const markRead = (id) => api.post(`${BASE_PATH}/mark_read`, { id });

const markAllRead = () => api.post(`${BASE_PATH}/mark_all_read`);

const dismiss = (id) => api.post(`${BASE_PATH}/dismiss`, { id });

// Switch positions for the optional notification types, keyed by type. Always-on
// types are not included — the server decides what a user may turn off.
const getPreferences = () => api.get(`${BASE_PATH}/preferences`);

// Partial update: send only what changed. Responds with the full set.
const updatePreferences = (preferences) => api.post(`${BASE_PATH}/preferences`, preferences);

const UserNotificationService = {
  list,
  getUnreadCount,
  markRead,
  markAllRead,
  dismiss,
  getPreferences,
  updatePreferences,
};

export default UserNotificationService;
